import { useEffect } from "react";

import {
  connectTicketMessagesSocket,
  disconnectTicketMessagesSocket,
} from "src/Services/socket/ticketMessagesSocket";

const useTicketMessagesRealtime = ({ ticketId, onRefresh }) => {
  useEffect(() => {
    if (!ticketId) {
      return undefined;
    }

    const socket = connectTicketMessagesSocket();
    const roomPayload = { ticketId };

    const joinRoom = () => {
      socket.emit("ticket-messages:join", roomPayload);
    };

    const handleTicketMessageChanged = (payload) => {
      if (
        Number(payload?.ticketId) !== Number(ticketId) ||
        document.visibilityState !== "visible"
      ) {
        return;
      }

      onRefresh?.();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") {
        return;
      }

      connectTicketMessagesSocket();
      joinRoom();
      onRefresh?.();
    };

    socket.on("connect", joinRoom);
    socket.on("ticket-message-changed", handleTicketMessageChanged);

    if (socket.connected) {
      joinRoom();
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      socket.off("connect", joinRoom);
      socket.off("ticket-message-changed", handleTicketMessageChanged);
      socket.emit("ticket-messages:leave", roomPayload);
      disconnectTicketMessagesSocket();
    };
  }, [ticketId, onRefresh]);
};

export default useTicketMessagesRealtime;
